import { type CamelCasedStudentNetworkEvent } from 'StudentNetworkEvent';
import { EVENT_TYPE_CONFIGS_MAP } from 'StudentNetworkEvent/StudentNetworkEventTypeConfigs';

export function isOnlineEvent(eventType: string) {
    const config = EVENT_TYPE_CONFIGS_MAP[eventType as keyof typeof EVENT_TYPE_CONFIGS_MAP];
    return config?.online ?? !config?.mappable;
}

export function getEventTypeName(eventType: string) {
    const config = EVENT_TYPE_CONFIGS_MAP[eventType as keyof typeof EVENT_TYPE_CONFIGS_MAP];
    if (!config) return eventType;
    return eventType.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export function formatEventDate(event: CamelCasedStudentNetworkEvent) {
    if (event.dateTbd) return event.dateTbdDescription ?? 'Date TBD';
    if (!event.startTime) return '';

    const date = new Date(event.startTime * 1000);
    return date
        .toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        })
        .toUpperCase();
}
